module.exports = __webpack_public_path__ + "media/images/e-bilet/about/search-9c229b07e8ee70f4c821500039699eb8.svg";